import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify';
import { FeedbackApi } from '../../apis/feedback-api';
import type { FeedbackRepository } from '../../services/shared-repositories';
import type { FeedbackData } from '../../types';

@injectable()
export class FeedbackRepositoryImpl implements FeedbackRepository {
    constructor(
        @inject(FeedbackApi) private feedbackApi: FeedbackApi
    ) {
    }

    feedback<T>(data: FeedbackData<T>) {
        return this.feedbackApi.feedbackPost(data);
    }
}
